export const zh = {
  "app.eyebrow": "线下聚会游戏",
  "app.title": "这可是你说的！",
  "common.back": "返回",
  "common.cancel": "取消",
  "common.close": "关闭",
  "common.confirm": "确认",
  "common.home": "首页",
  "common.seat": "座位",
  "common.round": "第 1 局",
  "language.switch": "切换界面语言",
  "language.short": "EN",

  "help.open": "帮助",
  "help.title": "关于 App",
  "help.intro": "《这可是你说的！》是一款 3–5 人面对面的聊天游戏。可用实体卡牌完成游戏。本 App 仅是模拟手牌和牌组的工具，游戏实际进程和规则运行由玩家们自己维护。",
  "help.offlineTitle": "完全离线运行",
  "help.offlineBody": "创建房间后每台手机利用房间号各自算出同一副牌，无需联网、也不会上传任何数据。",
  "help.privacyTitle": "",
  "help.privacyBody": "",
  "help.releaseTitle": "版本信息",
  "help.versionLabel": "App 版本",
  "help.revisionLabel": "Git 提交",
  "help.buildTimeLabel": "构建时间（UTC）",
  "help.buildPlatformLabel": "构建环境",

  "tutorial.open": "怎么玩",
  "tutorial.title": "怎么玩",
  "tutorial.body": "详细玩法教程即将上线。现在可以先创建或加入一个房间，跟着屏幕提示上手。",
  "tutorial.dismiss": "知道了",

  "home.createAction": "创建房间",
  "home.joinAction": "加入房间",
  "home.resumeEyebrow": "进行中的本地局",
  "home.resumeTitle": "继续座位上的游戏",
  "home.resumeSummary": "{{theme}}·座位{{seat}} （进行中）",
  "home.resumeAction": "继续本局",
  "home.newAction": "离开房间",

  "create.title": "创建房间",
  "create.playerCount": "玩家人数",
  "create.theme": "卡牌主题",
  "create.randomTheme": "随机",
  "create.randomThemeLabel": "随机选择一个卡牌主题",
  "create.submit": "创建房间",
  "create.creating": "正在生成房间…",

  "join.title": "加入房间",
  "join.prompt": "请扫描房主的二维码，或输入房间号加入。",
  "join.codeLabel": "房间号",
  "join.placeholder": "6 位房间号",
  "join.submit": "加入房间",

  "room.title": "邀请其他玩家加入",
  "room.body": "扫描二维码，或手动输入房间号。",
  "room.codeLabel": "房间号",
  "room.copy": "复制房间号",
  "room.copied": "已复制房间号",
  "room.copyFailed": "复制失败，请手动记下上方房间号。",
  "room.qrLoading": "正在本地生成二维码",
  "room.qrAlt": "加入本局的二维码",
  "room.continue": "邀请完毕，现在去选座",

  "seat.title": "选择你的座位",
  "seat.body": "请所有人举起手机，确认各自座位号不重合。",
  "seat.roomLabel": "房间号",
  "seat.selected": "已选",
  "seat.confirm": "已确认所有人座位都不一样",

  "theme.eyebrow": "本局主题",
  "theme.icebreakers": "话题",
  "theme.continue": "查看我的手牌",

  "privacy.eyebrow": "私密牌面",
  "privacy.title": "牌面已盖住",
  "privacy.body": "确认只有你能看到屏幕，再打开手牌。",
  "privacy.show": "点击查看手牌",

  "hand.title": "我的手牌",
  "hand.cards": "手牌",
  "hand.penalty": "罚牌",
  "hand.penaltyRemaining": "剩余罚牌",
  "hand.draw": "罚牌堆",
  "hand.drawWithCount": "罚牌堆（{{count}}）",
  "hand.reveal": "公示此牌",
  "hand.revealPrompt": "请选牌",
  "hand.cover": "隐藏手牌",
  "hand.uncover": "显示手牌",
  "hand.viewTheme": "查看主题",
  "hand.history": "弃牌堆",
  "hand.historyWithCount": "弃牌堆（{{count}}）",
  "hand.accuse": "指控！",
  "hand.emptyTitle": "你没有手牌",
  "hand.emptyBody": "",
  "hand.drawn": "已按顺序抽入一张罚牌",
  "hand.discarded": "已把这张牌移入弃牌记录",
  "hand.restored": "已撤销最近一次弃牌",

  "card.dual": "双赢牌",
  "card.normal": "普通牌",

  "reveal.title": "公示给全桌",
  "reveal.putBack": "放回",
  "reveal.discard": "弃牌",
  "reveal.discardConfirmTitle": "确认弃掉这张牌？",
  "reveal.discardConfirmBody": "这张牌会移入你的弃牌记录，可在弃牌记录里撤销。",
  "reveal.discardConfirm": "确认弃牌",
  "reveal.historyTitle": "重新公示",
  "reveal.historyDone": "公示完成",

  "history.title": "弃牌堆",
  "history.body": "点一张牌可以再次公示。",
  "history.empty": "还没有弃牌。",
  "history.showAgain": "重新公示",
  "history.undo": "撤销上次弃牌",
  "history.back": "返回手牌",
  "history.putBack": "放回弃牌堆",
  "history.count": "{{count}} 张牌",

  "draw.prompt": "从罚牌堆顶抽取下一张",
  "draw.remaining": "剩余 {{count}} 张",

  "modal.drawTitle": "确认抽一张罚牌？",
  "modal.drawBody": "此操作不可撤销",
  "modal.drawConfirm": "抽牌",
  "modal.noPenaltyTitle": "没有可抽的罚牌",
  "modal.noPenaltyBody": "无牌可抽意味着你已出局",
  "modal.dismiss": "知道了",

  "reset.title": "离开这个房间？",
  "reset.body": "离开后这台手机上的手牌、罚牌和弃牌记录会被清除；其他玩家不受影响。",
  "reset.confirm": "离开房间",

  "error.session": "创建失败，请稍后再试。",
  "error.join": "加入失败：请检查房间号是否正确、位数是否为 6 位。",
  "error.boundaryTitle": "这个界面没有正确打开",
  "error.boundaryBody": "你的本地存档仍保留在浏览器中。重新载入后会先回到安全遮罩。",
  "error.reload": "重新载入"
} as const;

export type TranslationKey = keyof typeof zh;

export const en: Record<TranslationKey, string> = {
  "app.eyebrow": "In-person party game",
  "app.title": "You Said It!",
  "common.back": "Back",
  "common.cancel": "Cancel",
  "common.close": "Close",
  "common.confirm": "Confirm",
  "common.home": "Home",
  "common.seat": "Seat",
  "common.round": "Round 1",
  "language.switch": "Switch interface language",
  "language.short": "中文",

  "help.open": "Help",
  "help.title": "About this app",
  "help.intro": "You Said It! is a face-to-face talking game for 3–5 players. The game can be played with physical cards. This app is only your private hand rack and dealer. The game progress and rules are run by the players themselves.",
  "help.offlineTitle": "Fully offline",
  "help.offlineBody": "Every phone derives the same deck on its own using room code — no network needed.",
  "help.privacyTitle": "",
  "help.privacyBody": "",
  "help.releaseTitle": "Release information",
  "help.versionLabel": "App version",
  "help.revisionLabel": "Git commit",
  "help.buildTimeLabel": "Built at (UTC)",
  "help.buildPlatformLabel": "Build environment",

  "tutorial.open": "How to play",
  "tutorial.title": "How to play",
  "tutorial.body": "A full tutorial is coming soon. For now, create or join a room and follow the on-screen prompts.",
  "tutorial.dismiss": "Got it",

  "home.createAction": "Create room",
  "home.joinAction": "Join room",
  "home.resumeEyebrow": "Local game in progress",
  "home.resumeTitle": "Return to your seat",
  "home.resumeSummary": "{{theme}} · Seat {{seat}} (In progress)",
  "home.resumeAction": "Resume game",
  "home.newAction": "Leave room",

  "create.title": "Create a room",
  "create.playerCount": "Players",
  "create.theme": "Card theme",
  "create.randomTheme": "Random",
  "create.randomThemeLabel": "Pick a random card theme",
  "create.submit": "Create room",
  "create.creating": "Creating the room…",

  "join.title": "Join a room",
  "join.prompt": "Scan the host's QR code, or type the room number to join.",
  "join.codeLabel": "Room number",
  "join.placeholder": "6-character room number",
  "join.submit": "Join room",

  "room.title": "Invite others",
  "room.body": "Scan the QR code below, or input the room number.",
  "room.codeLabel": "Room number",
  "room.copy": "Copy room number",
  "room.copied": "Room number copied",
  "room.copyFailed": "Copy failed. Please note the room number above manually.",
  "room.qrLoading": "Generating the QR code locally",
  "room.qrAlt": "QR code for joining this game",
  "room.continue": "Invitation done, now pick seats",

  "seat.title": "Choose your seat",
  "seat.body": "Pick a number nobody else is using, then hold up your phone so everyone can confirm the room number matches and every seat is unique.",
  "seat.roomLabel": "Room number",
  "seat.selected": "Selected",
  "seat.confirm": "Everyone's seat is different",

  "theme.eyebrow": "Game theme",
  "theme.icebreakers": "Topics",
  "theme.continue": "View my hand",

  "privacy.eyebrow": "Private cards",
  "privacy.title": "Your cards are covered",
  "privacy.body": "Make sure only you can see the screen before opening your hand.",
  "privacy.show": "Tap to view your hand",

  "hand.title": "My hand",
  "hand.cards": "Cards",
  "hand.penalty": "Penalty cards",
  "hand.penaltyRemaining": "Penalty cards left",
  "hand.draw": "Penalty Deck",
  "hand.drawWithCount": "Penalty Deck ({{count}})",
  "hand.reveal": "Reveal this card",
  "hand.revealPrompt": "Pick a card",
  "hand.cover": "Hide",
  "hand.uncover": "Show",
  "hand.viewTheme": "Theme",
  "hand.history": "Discard Deck",
  "hand.historyWithCount": "Discard Deck ({{count}})",
  "hand.accuse": "Accuse!",
  "hand.emptyTitle": "You have no cards",
  "hand.emptyBody": "",
  "hand.drawn": "Drew the next penalty card in order",
  "hand.discarded": "Moved the card to your discard deck",
  "hand.restored": "Restored your latest discard",

  "card.dual": "Dual-win card",
  "card.normal": "Normal card",

  "reveal.title": "Show the table",
  "reveal.putBack": "Put back in hand",
  "reveal.discard": "Discard this card",
  "reveal.discardConfirmTitle": "Discard this card?",
  "reveal.discardConfirmBody": "It moves to your discard deck and can be undone there.",
  "reveal.discardConfirm": "Confirm discard",
  "reveal.historyTitle": "Show again",
  "reveal.historyDone": "Done showing",

  "history.title": "Discard Deck",
  "history.body": "Tap a card to show it again.",
  "history.empty": "No discarded cards yet.",
  "history.showAgain": "Show again",
  "history.undo": "Undo last discard",
  "history.back": "Back to hand",
  "history.putBack": "Return to discard deck",
  "history.count": "{{count}} cards",

  "draw.prompt": "Draw the next card from the penalty deck",
  "draw.remaining": "{{count}} remaining",

  "modal.drawTitle": "Draw a penalty card?",
  "modal.drawBody": "This cannot be undone",
  "modal.drawConfirm": "Draw",
  "modal.noPenaltyTitle": "No penalty card available",
  "modal.noPenaltyBody": "No card to draw - you are out",
  "modal.dismiss": "Got it",

  "reset.title": "Leave this room?",
  "reset.body": "Leaving clears this phone's hand, penalty cards, and discard history. Other players are unaffected.",
  "reset.confirm": "Leave room",

  "error.session": "Could not create the room. Please try again.",
  "error.join": "Could not join. Check the room number and that it is 6 characters.",
  "error.boundaryTitle": "This screen did not open correctly",
  "error.boundaryBody": "Your local save is still stored in this browser. Reloading returns to a safe cover first.",
  "error.reload": "Reload"
};

export const resources = {
  zh: { translation: zh },
  en: { translation: en }
} as const;
